// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonMenu-module_content__foiaL {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/buttonMenu.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,gBAAgB;AACpB","sourcesContent":[".content {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `buttonMenu-module_content__foiaL`
};
export default ___CSS_LOADER_EXPORT___;
